import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Tiebreakers from "../../constants/Tiebreakers";
import {
  Accordion,
  AccordionSummary,
  DialogContentText,
  Typography,
  IconButton,
  ListSubheader,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import DeleteIcon from "@material-ui/icons/Delete";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export default class TiebreakersDialog extends React.Component {
  state = {
    anchorEl: null,
    anchorElSub: null,
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuSub = (event) => {
    this.setState({ anchorElSub: event.currentTarget });
  };

  handleCloseSub = () => {
    this.setState({ anchorElSub: null });
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          {languages.tiebreakers.rankingLabel}
        </DialogTitle>
        <DialogContent style={{ paddingTop: 0 }}>
          <DialogContentText style={{ paddingBottom: 5 }}>
            {languages.tiebreakers.rankingDescription2}
          </DialogContentText>
          <div style={{ width: "100%" }}>
            <DragDropContext onDragEnd={this.props.onDragEnd}>
              <Droppable droppableId="criteriumDrop">
                {(provided, snapshot) => {
                  return (
                    <div ref={provided.innerRef}>
                      {this.props.tiebreakers.map((t, i) => {
                        let tiebreaker = Tiebreakers[t.id];
                        if (
                          t.custom &&
                          (this.props.tournament.customPoints || {})[t.id]
                        ) {
                          tiebreaker = {
                            id: t.id,
                            label:
                              (
                                (this.props.tournament.customPoints || {})[
                                  t.id
                                ] || {}
                              ).name || "",
                          };
                        }
                        return (
                          <Draggable key={t.id} draggableId={t.id} index={i}>
                            {(provided, snapshot) => (
                              <div>
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <Accordion square>
                                    <AccordionSummary
                                      expandIcon={
                                        tiebreaker.subCriteria ? (
                                          <ExpandMoreIcon />
                                        ) : null
                                      }
                                      aria-label="Expand"
                                      aria-controls="additional-actions1-content"
                                      id="additional-actions1-header"
                                    >
                                      <Typography
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {i +
                                          1 +
                                          ". " +
                                          (this.props.useSets &&
                                          tiebreaker.label_sets
                                            ? tiebreaker.label_sets
                                            : tiebreaker.label)}
                                      </Typography>
                                      {t.custom && (
                                        <Button
                                          aria-label="edit"
                                          onClick={(e) => {
                                            this.props.handleDirectionToggle(
                                              t.id,
                                              !t.desc
                                            );
                                            e.stopPropagation();
                                          }}
                                          size="small"
                                          style={{ marginLeft: 10 }}
                                          endIcon={
                                            t.desc ? (
                                              <ArrowDownward />
                                            ) : (
                                              <ArrowUpward />
                                            )
                                          }
                                        >
                                          {t.desc
                                            ? languages.structure
                                                .ownStatisticsLeast
                                            : languages.structure
                                                .ownStatisticsMost}
                                        </Button>
                                      )}
                                      <IconButton
                                        aria-label="edit"
                                        onClick={(e) => {
                                          this.props.handleDeleteCriterium(
                                            t.id
                                          );
                                        }}
                                        size="small"
                                        style={{
                                          marginLeft: "auto",
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </AccordionSummary>
                                    <DragDropContext
                                      onDragEnd={this.props.onDragEnd}
                                    >
                                      <Droppable droppableId="subCriteriumDrop">
                                        {(provided, snapshot) => {
                                          return (
                                            <div ref={provided.innerRef}>
                                              {tiebreaker.subCriteria &&
                                                (t.subCriteria || [])
                                                  .filter((sc) =>
                                                    sc.custom
                                                      ? (this.props.tournament
                                                          .customPoints || {})[
                                                          sc.id
                                                        ] !== undefined
                                                      : true
                                                  )
                                                  .map((subT, subI) => {
                                                    let tiebreaker =
                                                      Tiebreakers[subT.id];
                                                    if (
                                                      subT.custom &&
                                                      (this.props.tournament
                                                        .customPoints || {})[
                                                        subT.id
                                                      ]
                                                    ) {
                                                      tiebreaker = {
                                                        id: subT.id,
                                                        label:
                                                          (
                                                            (this.props
                                                              .tournament
                                                              .customPoints ||
                                                              {})[subT.id] || {}
                                                          ).name || "",
                                                      };
                                                    }
                                                    return (
                                                      <Draggable
                                                        key={"sub-" + subT.id}
                                                        draggableId={
                                                          "sub-" + subT.id
                                                        }
                                                        index={subI}
                                                        type="subCriterium"
                                                      >
                                                        {(
                                                          provided,
                                                          snapshot
                                                        ) => (
                                                          <div>
                                                            <div
                                                              ref={
                                                                provided.innerRef
                                                              }
                                                              {...provided.draggableProps}
                                                              {...provided.dragHandleProps}
                                                            >
                                                              <AccordionSummary
                                                                aria-label="Expand"
                                                                aria-controls="additional-actions1-content"
                                                                id="additional-actions1-header"
                                                                style={{
                                                                  paddingLeft: 47,
                                                                  borderTop:
                                                                    "1px solid rgba(0, 0, 0, 0.12)",
                                                                }}
                                                                key={subI}
                                                              >
                                                                <Typography
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  {i +
                                                                    1 +
                                                                    "." +
                                                                    (subI + 1) +
                                                                    ". " +
                                                                    (this.props
                                                                      .useSets &&
                                                                    tiebreaker.label_sets
                                                                      ? tiebreaker.label_sets
                                                                      : tiebreaker.label)}
                                                                </Typography>
                                                                {subT.custom && (
                                                                  <IconButton
                                                                    aria-label="edit"
                                                                    onClick={(
                                                                      e
                                                                    ) => {
                                                                      this.props.handleDirectionToggleSub(
                                                                        subT.id,
                                                                        !subT.desc
                                                                      );
                                                                    }}
                                                                    size="small"
                                                                  >
                                                                    {subT.desc ? (
                                                                      <ArrowDownward />
                                                                    ) : (
                                                                      <ArrowUpward />
                                                                    )}
                                                                  </IconButton>
                                                                )}
                                                                <IconButton
                                                                  aria-label="edit"
                                                                  onClick={(
                                                                    e
                                                                  ) => {
                                                                    this.props.handleDeleteSubCriterium(
                                                                      subT.id
                                                                    );
                                                                  }}
                                                                  size="small"
                                                                  style={{
                                                                    marginLeft:
                                                                      "auto",
                                                                  }}
                                                                >
                                                                  <DeleteIcon />
                                                                </IconButton>
                                                              </AccordionSummary>
                                                            </div>
                                                            {
                                                              provided.placeholder
                                                            }
                                                          </div>
                                                        )}
                                                      </Draggable>
                                                    );
                                                  })}
                                              {provided.placeholder}
                                            </div>
                                          );
                                        }}
                                      </Droppable>
                                    </DragDropContext>
                                    {t.id === "headToHead" && (
                                      <div>
                                        <div
                                          style={{
                                            marginLeft: 47,
                                            marginBottom: 15,
                                          }}
                                        >
                                          <FormControlLabel
                                            control={
                                              <Switch
                                                checked={
                                                  t.applyRecursively || false
                                                }
                                                onChange={
                                                  this.props.handleSwitch
                                                }
                                                color="primary"
                                                name="applyHeadToHeadRecursively"
                                              />
                                            }
                                            label={languages.formatString(
                                              languages.tiebreakers
                                                .applyHeadToHeadRecursively,
                                              this.props.tournament
                                                .individualPlayers
                                                ? languages.teams.playersLow
                                                : languages.tournament.teamsLow
                                            )}
                                          />
                                        </div>
                                        <div>
                                          <Button
                                            variant="outlined"
                                            color="default"
                                            onClick={this.handleMenuSub}
                                            style={{
                                              marginLeft: 47,
                                              marginBottom: 15,
                                            }}
                                          >
                                            {
                                              languages.tiebreakers
                                                .addHeadToHeadCriterium
                                            }
                                          </Button>
                                          <Menu
                                            id="simple-menu"
                                            anchorEl={this.state.anchorElSub}
                                            keepMounted
                                            open={Boolean(
                                              this.state.anchorElSub
                                            )}
                                            onClose={this.handleCloseSub}
                                          >
                                            {Object.keys(Tiebreakers).map(
                                              (key, i) => {
                                                const c = Tiebreakers[key];
                                                const disabled =
                                                  t.subCriteria.find(
                                                    (tb) => tb.id === key
                                                  ) !== undefined;
                                                if (
                                                  (!this.props.useSets &&
                                                    c.sets) ||
                                                  c.id === "headToHead"
                                                ) {
                                                  return null;
                                                }
                                                return (
                                                  <MenuItem
                                                    key={i}
                                                    onClick={() => {
                                                      this.props.handleAddSubCriterium(
                                                        c.id
                                                      );
                                                      this.handleCloseSub();
                                                    }}
                                                    disabled={disabled}
                                                  >
                                                    {this.props.useSets &&
                                                    c.label_sets
                                                      ? c.label_sets
                                                      : c.label}
                                                  </MenuItem>
                                                );
                                              }
                                            )}
                                            {Object.keys(
                                              this.props.tournament
                                                .customPoints || {}
                                            ).length > 0 && (
                                              <ListSubheader>
                                                {
                                                  languages.structure
                                                    .ownStatistics
                                                }
                                              </ListSubheader>
                                            )}
                                            {Object.keys(
                                              this.props.tournament
                                                .customPoints || {}
                                            ).length > 0 &&
                                              Object.keys(
                                                this.props.tournament
                                                  .customPoints || {}
                                              ).map((key) => {
                                                const customPoint =
                                                  this.props.tournament
                                                    .customPoints[key];
                                                const disabled =
                                                  t.subCriteria.find(
                                                    (tb) => tb.id === key
                                                  ) !== undefined;
                                                return (
                                                  <MenuItem
                                                    key={key}
                                                    onClick={() => {
                                                      this.props.handleAddSubCriterium(
                                                        key,
                                                        true
                                                      );
                                                      this.handleCloseSub();
                                                    }}
                                                    disabled={disabled}
                                                  >
                                                    {customPoint.name}
                                                  </MenuItem>
                                                );
                                              })}
                                          </Menu>
                                        </div>
                                      </div>
                                    )}
                                  </Accordion>
                                </div>
                                {provided.placeholder}
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  );
                }}
              </Droppable>
            </DragDropContext>
            <div>
              <Button
                variant="outlined"
                color="default"
                onClick={this.handleMenu}
                style={{ marginTop: 10, width: "100%" }}
              >
                {languages.tiebreakers.addCriterium}
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorEl}
                keepMounted
                open={Boolean(this.state.anchorEl)}
                onClose={this.handleClose}
              >
                {Object.keys(Tiebreakers).map((t, i) => {
                  const c = Tiebreakers[t];
                  const disabled =
                    this.props.tiebreakers.find((tb) => tb.id === c.id) !==
                    undefined;
                  if (!this.props.useSets && c.sets) {
                    return null;
                  }
                  return (
                    <MenuItem
                      key={i}
                      onClick={() => {
                        this.props.handleAddCriterium(c.id);
                        this.handleClose();
                      }}
                      disabled={disabled}
                    >
                      {this.props.useSets && c.label_sets
                        ? c.label_sets
                        : c.label}
                    </MenuItem>
                  );
                })}
                {Object.keys(this.props.tournament.customPoints || {}).length >
                  0 && (
                  <ListSubheader>
                    {languages.structure.ownStatistics}
                  </ListSubheader>
                )}
                {Object.keys(this.props.tournament.customPoints || {}).length >
                  0 &&
                  Object.keys(this.props.tournament.customPoints || {}).map(
                    (key) => {
                      const customPoint =
                        this.props.tournament.customPoints[key];
                      const disabled =
                        this.props.tiebreakers.find((tb) => tb.id === key) !==
                        undefined;
                      return (
                        <MenuItem
                          key={key}
                          onClick={() => {
                            this.props.handleAddCriterium(key, true);
                            this.handleClose();
                          }}
                          disabled={disabled}
                        >
                          {customPoint.name}
                        </MenuItem>
                      );
                    }
                  )}
              </Menu>
              {!this.props.tiebreakersAreDefault && (
                <Button
                  variant="outlined"
                  color="default"
                  onClick={this.props.backToDefault}
                  style={{ marginTop: 10, width: "100%" }}
                >
                  {languages.tiebreakers.backToDefault}
                </Button>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleSubmit}
            disabled={!this.props.submitEnabled}
            variant="contained"
            color="primary"
            type="submit"
          >
            {languages.general.save}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
